import { useFlags } from '@/hooks/useFlags';

/**
 * LaunchDarkly `amplitude-autocapture` (camelCase in `useFlags`).
 * Use this instead of `ldClient.variation()` so toggles re-render consumers.
 */
export const useAmplitudeAutocaptureEnabled = (): boolean => {
  const { amplitudeAutocapture } = useFlags();
  return amplitudeAutocapture === true;
};
